import Mark from 'mark.js';
import ReactHtmlParser from 'react-html-parser';
import { AppointmentHelpers, DataHelpers } from '.';
import {
  TYPE_MENTION_ALL,
  TYPE_MENTION_GROUP,
  TYPE_MENTION_USER,
} from '../constants/Types';

export function capitalize(word) {
  return `${word.charAt(0).toUpperCase()}${word.slice(1)}`;
}

export function capitalizeProp(prop) {
  return (item) => {
    const itemClone = { ...item };

    itemClone[prop] = capitalize(itemClone[prop]);

    return itemClone;
  };
}

export function formatFilename(filename) {
  const extension = filename.split('.').pop();
  const name = filename.split('.').slice(0, -1).join('.');
  let retVal = filename;
  if (name.length > 10) {
    retVal = `${name.substring(0, 10)}...${extension}`;
  }

  return retVal;
}

export function titleCase(word) {
  return word.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
}

export function highlightSearchedText(text, searchString) {
  const element = document.createElement('span');
  element.innerHTML = text;
  const instance = new Mark(element);
  instance.mark(searchString, {
    element: 'strong',
    separateWordSearch: false,
    diacritics: false,
  });
  return ReactHtmlParser(element.innerHTML);
}

export function removeAllWhiteSpace(string) {
  // This Regex matches all spaces, tabs, and new lines.
  return string.replace(/\s/g, '');
}

export function replaceUnderscoresWithSpaces(stringData) {
  return stringData.replace(/_/g, ' ');
}

export function formatCamelCaseToSpaces(camelCaseString) {
  return camelCaseString.split(/(?=[A-Z])/).join(' ');
}

export function replaceWhiteSpaceWithSpace(string) {
  return string.replace(/\s+/g, ' ');
}

export function replaceZeroWidthWhiteSpace(string) {
  return string.replace(/[\u200B-\u200D\uFEFF]/g, '');
}

export function removeSpecialCharacters(string) {
  return string.replace(/[^a-zA-Z0-9]/g, '');
}

export function luhnAlgorithm(cardNumberNoSpaces) {
  const arr = cardNumberNoSpaces
    .split('')
    .reverse()
    .map((x) => parseInt(x, 10));

  const lastDigit = arr.splice(0, 1)[0];
  let sum = arr.reduce((acc, val, i) => (i % 2 !== 0 ? acc + val : acc + ((val * 2) % 9) || 9), 0);
  sum += lastDigit;

  return sum % 10 === 0;
}

/**
 * @function removePeriodsFromString
 * Remove all periods from a string.
 *
 * EXAMPLES:
 * '1.11'           --> "111"
 * '1.00'           --> "100"
 * 'hello.world.c'  --> "helloworldc"
 *
 * @param {String} string String to be processed.
 * @returns {String} original string with all periods ('.') removed.
 */
export const removePeriodsFromString = (string) => string.replace(/\./g, '');

export const replaceInboxVariablesByValue = (message, options) => {
  let formattedMessage = message;
  const { activeUser, currentUser, userOrganization, appointments } = options;
  const { firstName, lastName, preferredName } = activeUser;
  const commaSeparatedAppointments = appointments.map((appointment) => (
    AppointmentHelpers.formatAppointmentTime(appointment.formattedAppointmentTime, 'dddd, MMM Do, YYYY', 'h:mm A')))
    .join(', ');
  formattedMessage = formattedMessage.replace(/{First_Name}/gi, firstName);
  formattedMessage = formattedMessage.replace(/{Last_Name}/gi, lastName);
  formattedMessage = formattedMessage.replace(/{Preferred_Name}/gi, `${DataHelpers.exists(preferredName) ? preferredName : firstName}`);
  formattedMessage = formattedMessage.replace(/{Appointment_Date_Time}/gi, commaSeparatedAppointments);
  formattedMessage = formattedMessage.replace(/{Organization_Name}/gi, userOrganization.name);
  formattedMessage = formattedMessage.replace(/{Sending_Member_First_Name}/gi, currentUser.firstName);
  formattedMessage = formattedMessage.replace(/{Sending_Member_Last_Name}/gi, currentUser.lastName);
  return formattedMessage;
};

export const getMentionPayload = (messageText, mentionableUserIds) => {
  const payload = {
    mentionUserIds: [],
    mentionGroupIds: [],
    mentionTypeId: TYPE_MENTION_USER,
  };
  const splitMessage = messageText.split(' ');
  splitMessage.forEach((el) => {
    if (el.includes('{userId-') && el.match(/{userId-(.*)}/).pop()) {
      const mentionedUserId = el.match(/{userId-(.*)}/).pop();
      if (mentionableUserIds.includes(Number(mentionedUserId))) {
        payload.mentionUserIds = [...new Set([...payload.mentionUserIds, Number(mentionedUserId)])];
        payload.mentionTypeId = TYPE_MENTION_USER;
      }
    } else if (el.includes('{groupId-') && el.match(/{groupId-(.*)}/).pop()) {
      const mentionedUserId = el.match(/{groupId-(.*)}/).pop();
      payload.mentionGroupIds = [...new Set([...payload.mentionGroupIds, Number(mentionedUserId)])];
      payload.mentionTypeId = TYPE_MENTION_GROUP;
    } else if (el.trim() === '{@All}') {
      payload.mentionTypeId = TYPE_MENTION_ALL;
    }
  });
  return payload;
};
